// FILE: app/not-found.tsx
"use client";

import Link from "next/link";
import JIBI from "@/components/mascot/JIBI";

export default function NotFound() {
  return (
    <div className="jibi404-root">
      {/* Lưới nền + sao bay */}
      <div className="jibi404-grid" aria-hidden />
      <div className="jibi404-stars" aria-hidden>
        {Array.from({ length: 14 }).map((_, i) => (
          <span key={i} className={`jibi404-star s${i % 4}`} style={{ "--i": i } as any}>
            ✦
          </span>
        ))}
      </div>

      <div className="jibi404-inner">
        {/* Số 404 với glitch nhẹ */}
        <div className="jibi404-code" data-text="404">
          404
        </div>

        {/* JIBI ở giữa, đứng trên "đường đứt" */}
        <div className="jibi404-mascot">
          <JIBI pose="waving" size="lg" animate />
        </div>

        <h1 className="jibi404-title">Ơ… JIBI bị lạc rồi!</h1>
        <p className="jibi404-desc">
          Trang bạn tìm không tồn tại, đã bị di chuyển, hoặc JIBI lỡ tay xoá mất.
          Cùng quay lại nơi an toàn nhé!
        </p>

        <div className="jibi404-actions">
          <Link href="/" className="jibi404-btn jibi404-btn--primary">
            🏠 Về trang chủ
          </Link>
          <Link href="/exams" className="jibi404-btn jibi404-btn--ghost">
            📝 Khám phá đề thi
          </Link>
        </div>
      </div>

      <style jsx>{`
        .jibi404-root {
          position: relative;
          min-height: 100vh;
          width: 100%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 32px 20px;
          background:
            radial-gradient(circle at 50% 35%, #154256 0%, #0f3a4a 45%, #092631 100%);
          font-family: var(--font-sans, system-ui, sans-serif);
        }

        /* Lưới phối cảnh chìm dưới đáy */
        .jibi404-grid {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(0, 212, 255, 0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 212, 255, 0.08) 1px, transparent 1px);
          background-size: 44px 44px;
          mask-image: linear-gradient(to bottom, transparent 55%, #000 100%);
          -webkit-mask-image: linear-gradient(to bottom, transparent 55%, #000 100%);
          pointer-events: none;
        }

        .jibi404-stars {
          position: absolute;
          inset: 0;
          pointer-events: none;
        }
        .jibi404-star {
          position: absolute;
          color: #7df9ff;
          font-size: 14px;
          opacity: 0.5;
          animation: twinkle 3s ease-in-out infinite;
          animation-delay: calc(var(--i) * 0.35s);
        }
        .jibi404-star.s0 { top: 12%; left: 14%; font-size: 18px; }
        .jibi404-star.s1 { top: 22%; left: 82%; font-size: 12px; }
        .jibi404-star.s2 { top: 68%; left: 8%; font-size: 16px; }
        .jibi404-star.s3 { top: 78%; left: 88%; font-size: 13px; }
        .jibi404-star:nth-child(5) { top: 8%; left: 48%; }
        .jibi404-star:nth-child(6) { top: 40%; left: 92%; }
        .jibi404-star:nth-child(7) { top: 86%; left: 30%; }
        .jibi404-star:nth-child(8) { top: 16%; left: 68%; }
        .jibi404-star:nth-child(9) { top: 58%; left: 78%; }
        .jibi404-star:nth-child(10) { top: 50%; left: 6%; }
        .jibi404-star:nth-child(11) { top: 30%; left: 24%; }
        .jibi404-star:nth-child(12) { top: 72%; left: 60%; }
        .jibi404-star:nth-child(13) { top: 24%; left: 38%; }
        .jibi404-star:nth-child(14) { top: 64%; left: 44%; }

        @keyframes twinkle {
          0%, 100% { opacity: 0.2; transform: scale(0.8); }
          50% { opacity: 0.9; transform: scale(1.15); }
        }

        .jibi404-inner {
          position: relative;
          z-index: 2;
          text-align: center;
          max-width: 520px;
          animation: rise 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
        }
        @keyframes rise {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* 404 chữ to, glitch */
        .jibi404-code {
          position: relative;
          font-family: var(--font-display, var(--font-sans, system-ui));
          font-size: clamp(96px, 22vw, 200px);
          font-weight: 800;
          line-height: 0.9;
          letter-spacing: -4px;
          color: transparent;
          background: linear-gradient(180deg, #ffffff 0%, #7df9ff 60%, #00d4ff 100%);
          -webkit-background-clip: text;
          background-clip: text;
          margin-bottom: -8px;
          user-select: none;
        }
        .jibi404-code::before,
        .jibi404-code::after {
          content: attr(data-text);
          position: absolute;
          inset: 0;
          background: inherit;
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        .jibi404-code::before {
          animation: glitch1 3.2s steps(2, end) infinite;
          opacity: 0.6;
        }
        .jibi404-code::after {
          animation: glitch2 2.6s steps(2, end) infinite;
          opacity: 0.4;
        }
        @keyframes glitch1 {
          0%, 92%, 100% { transform: translate(0, 0); }
          93% { transform: translate(-4px, 2px); }
          96% { transform: translate(3px, -2px); }
        }
        @keyframes glitch2 {
          0%, 90%, 100% { transform: translate(0, 0); }
          91% { transform: translate(3px, 1px); }
          95% { transform: translate(-3px, -1px); }
        }

        .jibi404-mascot {
          display: flex;
          justify-content: center;
          margin: 4px 0 8px;
          filter: drop-shadow(0 12px 30px rgba(0, 212, 255, 0.25));
        }

        .jibi404-title {
          font-family: var(--font-display, var(--font-sans, system-ui));
          font-size: clamp(22px, 5vw, 30px);
          font-weight: 800;
          color: #ffffff;
          margin: 8px 0 10px;
        }
        .jibi404-desc {
          font-size: 14px;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.62);
          margin: 0 auto 26px;
          max-width: 380px;
        }

        .jibi404-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .jibi404-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 13px 26px;
          border-radius: 999px;
          font-size: 14px;
          font-weight: 700;
          text-decoration: none;
          transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
        }
        .jibi404-btn--primary {
          background: linear-gradient(135deg, #00d4ff, #0066ff);
          color: #ffffff;
          box-shadow: 0 6px 20px rgba(0, 153, 255, 0.4);
        }
        .jibi404-btn--primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 28px rgba(0, 153, 255, 0.55);
        }
        .jibi404-btn--ghost {
          background: rgba(255, 255, 255, 0.08);
          color: #ffffff;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        .jibi404-btn--ghost:hover {
          transform: translateY(-2px);
          background: rgba(255, 255, 255, 0.14);
        }

        @media (prefers-reduced-motion: reduce) {
          .jibi404-star,
          .jibi404-code::before,
          .jibi404-code::after,
          .jibi404-inner {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
